import { makeStyles } from '@material-ui/core/styles'
import {
  CALLOUT_BACKGROUND,
  CALLOUT_FOREGROUND,
  OUTLINED_INPUT_BORDER,
} from 'lib/form-field-styles'
import { SEGMENTED_BUTTON_BORDER_RADIUS } from 'lib/segmented-button-styles'

export const usePillChipFieldStyles = makeStyles(theme => ({
  chipRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  chip: {
    borderRadius: SEGMENTED_BUTTON_BORDER_RADIUS,
    border: `1px solid ${OUTLINED_INPUT_BORDER}`,
    textTransform: 'none',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.25,
    color: CALLOUT_FOREGROUND,
    padding: theme.spacing(1.5, 3),
    minWidth: 88,
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      borderColor: OUTLINED_INPUT_BORDER,
    },
  },
  chipSelected: {
    backgroundColor: CALLOUT_BACKGROUND,
    color: CALLOUT_FOREGROUND,
    borderColor: 'transparent',
    '&:hover': {
      backgroundColor: CALLOUT_BACKGROUND,
      borderColor: 'transparent',
    },
  },
}))
